import * as yup from "yup";

export const ScreenPermissionsSetupValidationSchema = yup.object().shape({
  screenId: yup.array().required("Screen is required"),
  name: yup.string().required("Permission Name is required"),
});
